import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { FileuploadService } from "src/app/services/fileupload.service";
declare var bootstrap: any;
@Component({
  selector: "app-school-registration",
  templateUrl: "./school-registration.component.html",
  styleUrls: ["./school-registration.component.css"],
})
export class SchoolRegistrationComponent implements OnInit {
  @ViewChild("myModal") modalElement!: ElementRef;
  myform: UntypedFormGroup;
  isEdit: boolean = false;
  tnt_code: string;
  editData: any = {};
  tenants: Array<any> = [];
  file: File;
  fileName: string;
  labelName: any = {};
  headingName: any = {};
  County: Array<any> = [];
  subCounty: Array<any> = [];
  Constituency: Array<any> = [];
  levels: Array<any> = [];
  beForm: Boolean = false;
  higherForm: Boolean = false;
  tvetForm: Boolean = false;
  userDetails: any = {};
  modalInstance: any;
  userData: any;
  sneType: string = "";
  sneDetail: string = "";

  constructor(
    private CommonService: CommonService,
    private fb: UntypedFormBuilder,
    private active: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private FileuploadService: FileuploadService
  ) {
    active.queryParams.subscribe((res) => {
      this.tnt_code = res.tntCode;
    });
    // this.getTenantData();
    // this.loadlabels();
    this.countyDropdowns();
    this.getLevels();
    // this.loadHeadings();
  }

  ngOnInit(): void {
    this.myform = this.fb.group({
      TNT_NAME: ["", Validators.required],
      TNT_STATUS: [true],
      TNT_PARENT_CODE: [""],
      TNT_DESCRIPTION: ["", Validators.required],
      // TNT_KEY: ["", Validators.required],
      TNT_CONCURRENT_AVSESSIONS: ["", Validators.required],
      TNT_USERSPERSESSION: ["", Validators.required],
      TenantLogoUrl: [""],
      SHOWLOGO: [false],
      allow_proctoring: [false],
      allow_exampad: [false],
      constituency: ["0"],
      simba_acc: [""],
      gpa_accno: [""],
      bankbranch: [""],
      bankname: [""],
      noofnonteaching_female: ["0"],
      noofnonteaching_male: ["0"],
      noofteaching_female: ["0"],
      noofteaching_male: ["0"],
      noofteaching_total: [{ value: 0, disabled: true }],
      noofnonteaching_total: [{ value: 0, disabled: true }],
      learnerenrolment_total: [{ value: 0, disabled: true }],
      snetype: [""],
      accommodation_type: ["0"],
      email: ["", Validators.required],
      gpi: [""],
      landmark: [""],
      applicationtype: ["0"],
      school_regno: [""],
      schoollocation: [""],
      enrollment_boys: ["0"],
      enrollment_girls: ["0"],
      schoollevel: ["0"],
      schoolnameincertificate: [""],
      latitude: [""],
      longitude: [""],
      mobileno: ["", Validators.required],
      sne_disabilitytype_otherdescription: [""],
    });

    if (this.tnt_code) {
      this.isEdit = true;
      this.getData();
    }
    this.calculateTotals();
  }

  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner();
  }

  loadlabels() {
    this.labelName = {};
    this.CommonService.getCall(
      `TenantRegistration/GetLabelValuesByTaskid/81/${localStorage.getItem(
        "TenantCode"
      )}`
    ).subscribe((res: any) => {
      this.labelName = res;
      console.log(res);
    });
  }

  loadHeadings() {
    this.headingName = {};
    this.CommonService.getCall(
      `EmsDynamicheadingLables/GetLabelValuesByTaskid/81/${localStorage.getItem(
        "TenantCode"
      )}`
    ).subscribe((res: any) => {
      this.headingName = res;
    });
  }

  getData() {
    this.activeSpinner();
    this.CommonService.postCall("EditTenant", {
      TNT_CODE: this.tnt_code,
    }).subscribe((res: any) => {
      this.deactivateSpinner();
      if (res instanceof Array) {
        this.editData = res[0];
        this.dataTransfer(res[0]);
      } else {
        this.editData = res;
        this.dataTransfer(res);
      }
    });
  }
  dataTransfer(data) {
    let ctrls = this.myform.controls;
    Object.keys(ctrls).map((key) => {
      let ctrl = ctrls[key];
      ctrl.setValue(data[key]);
    });
    ctrls["TNT_KEY"].setValue(moment(data["TNT_KEY"]).format("yyyy-MM-DD"));
  }
  onSubmit(form: UntypedFormGroup) {
    let value = Object.assign({}, form.getRawValue());
    value["TNT_CREATEDBY"] = 54039871;
    value["TNT_PARENT_CODE"] = 90076444;
    value["TNT_KEY"] = "2027-06-30";
    value["sne_disability_status"] = this.sneType;
    value["sne_disability_type"] = this.sneDetail;
    this.activeSpinner();

    if (this.isEdit) {
      value["TNT_CODE"] = 90076444;
      this.CommonService.postCall("UpdateTenant", value).subscribe(
        (res: any) => {
          this.toastr.success("Tenant Updated Successfully");
          this.deactivateSpinner();
          // this.close();
        },
        (err) => {
          this.deactivateSpinner();
          this.toastr.error(err.error ? err.error : "Tenant not Updated");
        }
      );
    } else {
      this.CommonService.postCall("SaveTenant", value).subscribe(
        (res: any) => {
          this.toastr.success(
            "Institution registration form submitted successfully"
          );
          this.deactivateSpinner();
          this.router.navigate(["/payment"], {
            queryParams: {
              typ: 10,
              wId: 0,
              uId: 54039871,
              stTnt: res?.TNT_CODE,
            },
          });
          // this.router.navigate(["/login"]);
          // this.close();
          // this.router.navigate(["HOME/components/payment"], {
          //   queryParams: {
          //     typ: 1,
          //     wId: 0,
          //     uId: localStorage.getItem("UserId"),
          //     stTnt: 88968955,
          //   },
          // });
        },
        (err) => {
          this.deactivateSpinner();
          this.toastr.error(err.error ? err.error : "Institution not Created");
        }
      );
    }
  }
  close() {
    window.history.back();
  }
  getTenantData() {
    let payLoad = {
      Decrypt_Role: localStorage.getItem("RoleId"),
      TNT_CODE: localStorage.getItem("TenantCode"),
    };
    this.activeSpinner();
    this.CommonService.postCall("LoadTenantByRoleId", payLoad).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        this.tenants = res;
      },
      (err) => {
        this.deactivateSpinner();
      }
    );
  }

  changeFile(event) {
    if (event.target.files.length > 0) {
      let file: File = event.target.files[0];
      let name = file.name;
      let filetype = name.split(".").pop();
      let types: Array<any> = ["png", "jpg", "PNG", "jpeg", "gif", "JPEG"];
      let check = types.includes(filetype);
      if (check) {
        this.file = file;
        this.upload();
      } else {
        // alert(' Please upload pdf and doc file formats only.')
        this.toastr.warning("Please upload image file formats only.");
        event.target.value = "";
      }
    }
  }

  upload() {
    if (!this.file) return;
    const formData = new FormData();
    formData.append("file", this.file);
    formData.append("ClientDocs", "ClientDocs");

    this.activeSpinner();
    this.FileuploadService.upload(formData, "UploadTenant").subscribe(
      (res: any) => {
        this.fileName = res.FilePath;
        if (this.fileName && res.FilePath) {
          // this.file = null;
          this.deactivateSpinner();
          this.myform.controls["TenantLogoUrl"].setValue(this.fileName);
        }
      },
      (err) => {
        this.toastr.warning(err.error ? err.error : "file not uploaded");
        this.deactivateSpinner();
      }
    );
  }

  countyDropdowns() {
    this.County = [];
    this.CommonService.postCall("ClustersMaster/GetCountiesListByKenya", {
      COUNTRY_NAME: "Kenya",
    }).subscribe(
      (res: any) => {
        this.County = res;
      },
      (err: any) => {
        return this.toastr.error(err.error ? err.error : "No County's found!");
      }
    );
  }

  subCounties(SubCountyId: any) {
    this.subCounty = [];
    this.CommonService.postCall("ClustersMaster/GetSubCountiesList", {
      counties_id: SubCountyId,
    }).subscribe(
      (res: any) => {
        this.subCounty = res;
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No Sub-County's found!");
      }
    );
    this.CommonService.postCall("ClustersMaster/GetCountyconstituenciesList", {
      counties_id: SubCountyId,
    }).subscribe(
      (res: any) => {
        this.Constituency = res;
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No Constituency found!");
      }
    );
  }
  getLevels() {
    this.levels = [];
    this.CommonService.postCall("TenantRegistration/GetSchoolLevel", {
      tenantcode: 90076444,
    }).subscribe((res: any) => {
      this.levels = res;
    });
  }
  // getForm(type: any) {
  //   if (type == "be") {
  //     this.beForm = true;
  //   } else if (type == "higherForm") {
  //     this.higherForm = true;
  //     this.beForm = false;
  //   } else {
  //     this.tvetForm = true;
  //     this.higherForm = false;
  //     this.beForm = false;
  //   }
  // }
  getForm(type: string) {
    this.beForm = type === "be";
    this.higherForm = type === "higherForm";
    this.tvetForm = type === "tvetForm";
  }
  validateEmail(event: any): void {
    const val = event.target.value.trim();
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

    if (!emailPattern.test(val)) {
      this.myform.get("email")?.setValue("");
      this.toastr.warning("Invalid Email, Please Input a Valid Email Address.");
      return;
    }

    const domain = val.split("@")[1];
    if (/\d/.test(domain)) {
      this.myform.get("email")?.setValue("");
      this.toastr.warning(
        'Numbers are not allowed in the domain part of the email (after "@").'
      );
      return;
    }
  }

  openPreviewModal() {
    if (this.myform.valid) {
      this.userDetails = this.myform.value;

      // Initialize bootstrap modal if not initialized yet
      if (!this.modalInstance) {
        this.modalInstance = new bootstrap.Modal(
          this.modalElement.nativeElement
        );
      }

      this.modalInstance.show();
    } else {
      this.myform.markAllAsTouched(); // show validation errors
    }
  }

  getLevelDescription(id: number | string): string {
    const level = this.levels.find((l) => l.level_id == id);
    return level ? level.level_desc : "";
  }
  getSubCountiesList(id: number | string): string {
    const subCounty = this.subCounty.find((l) => l.sub_counties_id == id);
    return subCounty ? subCounty.sub_counties_name : "";
  }
  getCountyList(id: number | string): string {
    const countyList = this.County.find((l) => l.COUNTIES_CODE == id);
    return countyList ? countyList.COUNTIES_NAME : "";
  }
  getConstituencyList(id: number | string): string {
    const constituencyList = this.Constituency.find(
      (l) => l.con_counties_id == id
    );
    return constituencyList ? constituencyList.con_counties_name : "";
  }
  checkEmail(event: any) {
    this.activeSpinner();
    this.CommonService.postCall("TenantRegistration/GetTenantByEmail", {
      email: event?.target.value,
    }).subscribe(
      (res: any) => {
        if (res.length) {
          this.userData = res[0];
          this.myform.patchValue({
            TNT_NAME: res[0].TNT_NAME || "",
            TNT_STATUS: res[0].TNT_STATUS ?? true,
            TNT_PARENT_CODE: res[0].TNT_PARENT_CODE || "",
            TNT_DESCRIPTION: res[0].TNT_DESCRIPTION || "",
            TNT_CONCURRENT_AVSESSIONS: res[0].TNT_CONCURRENT_AVSESSIONS || "",
            TNT_USERSPERSESSION: res[0].TNT_USERSPERSESSION || "",
            TenantLogoUrl: res[0].TenantLogoUrl || "",
            SHOWLOGO: res[0].SHOWLOGO ?? false,
            allow_proctoring: res[0].allow_proctoring ?? false,
            allow_exampad: res[0].allow_exampad ?? false,
            simba_acc: res[0].simba_acc || "",
            gpa_accno: res[0].gpa_accno || "",
            bankbranch: res[0].bankbranch || "",
            bankname: res[0].bankname || "",
            noofnonteaching_female: res[0].noofnonteaching_female || "0",
            noofnonteaching_male: res[0].noofnonteaching_male || "0",
            noofteaching_female: res[0].noofteaching_female || "0",
            noofteaching_male: res[0].noofteaching_male || "0",
            snetype: res[0].snetype || "",
            accommodation_type: res[0].accommodation_type || "0",
            // email: res[0].email || "",
            gpi: res[0].gpi || "",
            landmark: res[0].landmark || "",
            applicationtype: res[0].applicationtype || "0",
            school_regno: res[0].school_regno || "",
            schoollocation: res[0].schoollocation || "",
            enrollment_boys: res[0].enrollment_boys || "0",
            enrollment_girls: res[0].enrollment_girls || "0",
            schoollevel: res[0].schoollevel || "0",
            schoolnameincertificate: res[0].schoolnameincertificate || "",
            latitude: res[0].latitude || "",
            longitude: res[0].longitude || "",
            mobileno: res[0].mobileno || "",
            constituency: res[0].constituency || "0",
            noofteaching_total: res[0]?.noofteaching_total,
            noofnonteaching_total: res[0]?.noofnonteaching_total,
            learnerenrolment_total: res[0]?.learnerenrolment_total,
            sne_disability_status: res[0]?.sne_disability_status,
            sne_disability_type: res[0]?.sne_disability_type,
            sne_disabilitytype_otherdescription:
              res[0]?.sne_disabilitytype_otherdescription,
          });

          this.subCounties(res[0]?.TNT_CONCURRENT_AVSESSIONS);
        }
        this.deactivateSpinner();
      },
      (e) => {
        if (e.error.message == "Email Already Exist") {
          this.myform.patchValue({
            email: "",
          });
          this.toastr.error(e.error.message);
        }
        this.deactivateSpinner();
      }
    );
  }
  calculateTotals() {
    this.myform
      .get("noofteaching_male")!
      .valueChanges.subscribe(() => this.updateTeachingTotal());
    this.myform
      .get("noofteaching_female")!
      .valueChanges.subscribe(() => this.updateTeachingTotal());

    this.myform
      .get("noofnonteaching_male")!
      .valueChanges.subscribe(() => this.updateNonTeachingTotal());
    this.myform
      .get("noofnonteaching_female")!
      .valueChanges.subscribe(() => this.updateNonTeachingTotal());

    this.myform
      .get("enrollment_boys")!
      .valueChanges.subscribe(() => this.updateEnrollmentTotal());
    this.myform
      .get("enrollment_girls")!
      .valueChanges.subscribe(() => this.updateEnrollmentTotal());
  }

  updateTeachingTotal() {
    const male = +this.myform.get("noofteaching_male")!.value || 0;
    const female = +this.myform.get("noofteaching_female")!.value || 0;
    this.myform
      .get("noofteaching_total")!
      .setValue(male + female, { emitEvent: false });
  }

  updateNonTeachingTotal() {
    const male = +this.myform.get("noofnonteaching_male")!.value || 0;
    const female = +this.myform.get("noofnonteaching_female")!.value || 0;
    this.myform
      .get("noofnonteaching_total")!
      .setValue(male + female, { emitEvent: false });
  }

  updateEnrollmentTotal() {
    const boys = +this.myform.get("enrollment_boys")!.value || 0;
    const girls = +this.myform.get("enrollment_girls")!.value || 0;
    this.myform
      .get("learnerenrolment_total")!
      .setValue(boys + girls, { emitEvent: false });
  }
}
